// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"story-tag-m__tag-wrapper__36ua3","tag-element":"story-tag-m__tag-element__1xi6c","story-tag":"story-tag-m__story-tag__1_J2M"};